<template>
  <nav aria-label="Skip link">
    <a href="#main" class="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:p-4 focus:bg-white focus:text-blue-600">Lewati ke konten utama</a>
  </nav>
  <RouterView />
</template>
